<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div>
  <div class="title-container">
  <h2>{{tableTitle}}</h2>
  <button mat-flat-button  *ngIf="isTableDownloadable"
    color="primary" (click)="exportToCsv()" class="export-button">
    <mat-icon>file_download</mat-icon>Export to CSV</button>
  </div>

  <div class="mat-elevation-z8 view-result-entry" [ngStyle]="displayOverflow()">
    <table mat-table [dataSource]="dataSource">
        <ng-container [matColumnDef]="column"
          *ngFor="let column of displayedColumns; index as i" [sticky]="isColumnSticky(i)">
            <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element[column]}}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>
  </div>
</div>
